import request from "../utils/request";

export const getExchangeRates = '/exchange/rate/'

export function modifyExchangeRate(data: any) {
    return request.request({
        url: '/exchange/rate/',
        method: data.id ? 'put' : 'post',
        data: data
    })
}

export function deleteExchangeRate(id: number) {
    return request.request({
        url: '/exchange/rate/',
        method: 'delete',
        params: {rateId: id}
    })
}
